
import { createClient } from '@supabase/supabase-js';

// Vite writes both values into the bundle at build time (Netlify's env, or .env.local in
// development). A bundle built without them throws here on load; there is no hardcoded key.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY: set both before building');
}

// Enhanced client with more robust session persistence settings
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'supabase.auth.token',
    storage: localStorage // Explicitly use localStorage for better persistence
  }
});
